import { defineStore } from "pinia";
import AuthService from "@/services/authService";
import router from "@/router";
import { getVeterinaire } from "@/api/auth";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: null,
    user: null,
    isLoading: false,
    clients: [],
  }),

  getters: {
    getClients: state => state.clients,
    isAuthenticated: state => {
      return AuthService.isAuthenticated() && !!state.token;
    },

    userRole: state => {
      return state.user?.role || null;
    },

    isVeterinaire: state => {
      return state.user?.role === "veterinaire";
    },

    isProprietaire: state => {
      return state.user?.role === "proprietaire";
    },

    tokenPayload: () => {
      return AuthService.getTokenPayload();
    },
  },

  actions: {
    async fetchClients() {
      if (this.clients.length > 0) {
        return;
      }
      if (this.user?.id) {
        try {
          this.isLoading = true;
          const response = await getVeterinaire(this.user.id);
          this.clients = response.data.clients || [];
        } catch (error) {
          console.error("Erreur lors de la récupération des clients:", error);
          // Gérer l'erreur, par exemple en affichant une notification
        } finally {
          this.isLoading = false;
        }
      }
    },
    initAuth() {
      AuthService.migrateOldTokens();
      const token = AuthService.getToken();
      const user = AuthService.getUser();

      if (token && AuthService.isTokenValid(token)) {
        this.token = token;
        this.user = user;
      } else {
        this.clearAuth();
      }
    },

    setToken(token) {
      if (token) {
        this.token = token;
        AuthService.setToken(token);
      }
    },

    setUser(user) {
      if (user) {
        this.user = user;
        AuthService.setUser(user);
      }
    },

    clearAuth() {
      this.token = null;
      this.user = null;
      AuthService.clearAuthData();
    },

    logout() {
      this.clearAuth();
      localStorage.clear();
      try {
        if (router.currentRoute.value.meta?.requiresAuth) {
          router.push({ name: "Home" });
        } else {
          router.push("/");
        }
      } catch (error) {
        window.location.href = "/";
      }
    },

    checkTokenValidity() {
      if (this.token && !AuthService.isTokenValid(this.token)) {
        console.warn("Token expiré, déconnexion automatique");
        this.logout();
        return false;
      }
      return true;
    },
  },

  persist: true,
});
